import { theme } from '@/utils/theme';

export const styles = {
  tooltip: {
    '& .MuiTooltip-tooltip': {
      fontSize: '0.8rem',
      backgroundColor: theme.palette['grey-8'].main,
      color: 'white',
      borderRadius: '8px',
    },
    '& .MuiTooltip-arrow': {
      color: theme.palette['grey-8'].main,
    },
  },
};
